/** Shared event names. Values preserve the existing Application Insights event names. */
export enum PortalTelemetryEvent {
    RouteViewed = 'RouteViewed',
    ScreenViewed = 'ScreenViewed',
    StepViewed = 'StepViewed',
    ActionSelected = 'ActionSelected',
    ApplicationSubmitted = 'ApplicationSubmitted',
    ValidationBlocked = 'ValidationBlocked',
    OperationStarted = 'OperationStarted',
    OperationCompleted = 'OperationCompleted',
    PaymentReturn = 'PaymentReturn',
    PaymentRedirect = 'PaymentRedirect',
    AccessBlocked = 'AccessBlocked',
    JourneyStarted = 'JourneyStarted',
    JourneyResumed = 'JourneyResumed',
    Navigation = 'Navigation',
    EligibilityBlocked = 'EligibilityBlocked',
    ApplicationPending = 'ApplicationPending',
    WorkDetailsConfirmed = 'WorkDetailsConfirmed',
    PaymentOptionSelected = 'PaymentOptionSelected',
    PaymentAttempt = 'PaymentAttempt',
    PaymentRetry = 'PaymentRetry',
    PrepaidDisplayed = 'PrepaidDisplayed'
}
